module.exports = __webpack_public_path__ + "img/mexico.57baf107.png";